import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import VisibilitySensor from 'react-visibility-sensor'
import scrollToElement from 'scroll-to-element'
import { getIndustryTimes, getNarrativeTimes } from '../utils/dataParsers'
import TimeCard from './TimeCard'
import TimesBar from './TimesBar'
import IndustryHero from './IndustryHero'
import { isMobile, isMobileOnly } from 'react-device-detect'
import WheelIndicator from 'wheel-indicator'
import CountUp from 'react-countup'
import '../css/Timeline.scss'
import NarrativeHero from './NarrativeHero'
import { ParallaxProvider } from 'react-scroll-parallax'
import ScrollDown from './../svg/down-arrow.svg'
import Container from 'react-bootstrap/Container'

export default class Timeline extends Component {
  constructor(props) {
    super(props)
    this.narrKey = this.props.match.params.narrative
    this.narrativeType = this.props.match.params.collectionType
    this.narrative = this.narrativeType === "industry" ? this.props.industries[this.narrKey] : this.props.narratives[this.narrKey]
    this.timeTarget = this.props.match.params.timepoint
    this.narrativeTimes = this.narrativeType === "industry"
      ? getIndustryTimes(this.narrKey, this.props.times).reverse()
      : getNarrativeTimes(this.narrKey, this.props.times).sort((a, b) => (a.year > b.year) ? -1 : 1)
    this.data = this.props.data

    /* Initial State */
    this.state = {
      isPinned: false,
      activeYear: this.narrativeTimes[0],
      displayYear: this.narrativeTimes[0].year,
      to: this.narrativeTimes[0].year,
      timePointSelected: true,
      activeIndex: 0,
      canScroll: true
    }

    /* Bind Functions */
    this.scrollUpdate = this.scrollUpdate.bind(this)
    this.countTo = this.countTo.bind(this)
    this.scrollToTime = this.scrollToTime.bind(this)
    this.updatePins = this.updatePins.bind(this)
    this.handleTouchMove = this.handleTouchMove.bind(this)
    this.handleTouchStart = this.handleTouchStart.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.goToTime = this.goToTime.bind(this)
    this.killListeners = this.killListeners.bind(this)
  }

  componentDidMount() {
    if (typeof this.timeTarget === 'string') {
      scrollToElement('#timeline-content', {
        offset: 200,
        duration: 200
      })
      setTimeout(() => {
        this.scrollToTime(this.narrativeTimes.find(targetTime => {
          return this.timeTarget === targetTime.key
        }))
      }, 200)
    } else {
      this.setState({
        timePointSelected: false
      })
    }
  }

  componentWillUnmount() {
    this.killListeners()
  }

  getNextIndex(direction, activeIndex) {
    const possibleIndex = direction === 'down' ? activeIndex + 1 : direction === 'up' ? activeIndex - 1 : activeIndex
    return possibleIndex >= -1 && possibleIndex < this.narrativeTimes.length ? possibleIndex : activeIndex
  }

  killListeners() {
    if (isMobile) {
      document.getElementById('timeline-content').removeEventListener('touchstart', this.handleTouchStart)
      document.getElementById('timeline-content').removeEventListener('touchmove', this.handleTouchMove)
    } else {
      document.removeEventListener('keydown', this.handleKeyDown)
      if (this.indicator) {
        this.indicator.destroy()
      }
    }
  }

  goToTime(direction) {
    const toIndex = this.getNextIndex(direction, this.state.activeIndex)
    if (toIndex === -1) {
      this.killListeners()
    } else {
      if (toIndex !== this.state.activeIndex) {
        this.setState({
          activeIndex: toIndex,
          activeYear: this.narrativeTimes[toIndex],
          displayYear: this.state.to
        })
        this.countTo(this.narrativeTimes[toIndex].year)
      }
    }
  }

  scrollUpdate(e) {
    e.preventDefault()
    const direction = e.direction
    this.goToTime(direction)
  }

  updatePins(heroVisible) {
    this.setState({
      isPinned: !heroVisible
    })
    if (!heroVisible) {
      document.documentElement.classList.add('scroll-lock');
      if (isMobile) {
        document.getElementById('timeline-content').addEventListener('touchstart', this.handleTouchStart, { passive: false })
        document.getElementById('timeline-content').addEventListener('touchmove', this.handleTouchMove, { passive: false })
      } else {
        document.addEventListener('keydown', this.handleKeyDown)
        this.indicator = new WheelIndicator({
          elem: document.getElementById('timeline-content'),
          callback: this.scrollUpdate,
          preventMouse: true
        })
      }
    } else {
      document.documentElement.classList.remove('scroll-lock');
      this.killListeners()
    }
  }

  countTo(to) {
    this.setState({
      to: to
    })
  }

  getTouches(e) {
    return e.touches || // browser API
      e.originalEvent.touches // jQuery
  }

  handleKeyDown(e) {
    switch (e.which) {
      case 38: // up
        e.preventDefault()
        this.goToTime('up')
        break
      case 40: // down
        e.preventDefault()
        this.goToTime('down')
        break
      default:
        break
    }
  }

  handleTouchStart(e) {
    // e.preventDefault()
    const firstTouch = this.getTouches(e)[0]
    this.xDown = firstTouch.clientX
    this.yDown = firstTouch.clientY
  }

  handleTouchMove(e) {
    e.preventDefault()
    if (!this.xDown || !this.yDown) { return }
    const yUp = e.touches[0].clientY
    const yDiff = this.yDown - yUp
    const direction = (yDiff > 0) ? 'down' : 'up'
    this.goToTime(direction)

    /* reset values */
    this.xDown = null
    this.yDown = null
  }

  scrollToTime(toTime) {
    const toIndex = this.narrativeTimes.indexOf(toTime)
    const newTime = this.narrativeTimes.find(time => time.key === toTime.key)
    if (toIndex > -1) {
      this.setState({
        activeIndex: toIndex,
        activeYear: newTime,
        displayYear: this.state.to
      })
      this.countTo(this.narrativeTimes[toIndex].year)
    }
  }

  render() {
    const {
      isPinned,
      // timePointSelected,
      activeYear,
      displayYear,
      to
    } = this.state

    let emptyCount = 0;

    return <div>
      <ParallaxProvider>
        <VisibilitySensor onChange={this.updatePins} partialVisibility>
          {this.narrativeType === "industry" ?
            <IndustryHero
              headline={this.narrative.title}
              subhead={this.narrative.category ? this.narrative.category : ''}
              body={this.narrative.desc}
              image={this.narrative.image}
              narrativeType={this.narrativeType}
            /> : <NarrativeHero
              headline={this.narrative.title}
              desc={this.narrative.desc}
              body={this.narrative.body}
              image={this.narrative.image}
            />}
        </VisibilitySensor>
        <div className={`${isPinned ? 'pinState' : ''}`} />
        <Link className={`backButton ${isPinned ? 'mini' : ''}`} to='/'>
          <img src={ScrollDown} alt={'Back to timeline'} />
          Back To Timeline
        </Link>
        <div id='timeline-content' className={`timeline-content ${isPinned ? 'pinned' : ''}`}>
          <Container>
            <div className={`timeline-date ${isMobileOnly ? ' mobile-timeline-date' : ''}`} >
              <h2>
                <span className={'displayed-year-industry'}>
                  <CountUp end={to} start={displayYear} duration={0.5} useEasing={false} />
                </span>
              </h2>
            </div>
            <TimesBar scrollToTime={this.scrollToTime} times={this.narrativeTimes} activeYear={activeYear} narrType={this.narrativeType} />
            <div className='times-container'>
              {
                this.narrativeTimes.map(timePoint => {
                  let emptyClass = ''
                  if (timePoint.image === '') {
                    emptyCount++
                    emptyClass = 'empty-' + (emptyCount % 3)
                  }
                  return (
                    <TimeCard data={this.props.data} timeData={timePoint} active={timePoint.key === activeYear.key} key={timePoint.key} emptyClass={emptyClass} />
                  )
                }
                )
              }
            </div>
          </Container>
        </div>
      </ParallaxProvider>
    </div>
  }
}
